<template>
<div>
  <div v-if="$route.name === 'setup'">
    <h3 class="mt-8 mb-6 text-3xl md:text-4xl relative font-medium">Look and Feel</h3>
    <p class="mt-2 text-lg">Choose your feedback link and brand your feedback survey with your logo and color.</p>
  </div>
  <div v-else>
    <h3 class="mt-8 mb-6 text-3xl md:text-4xl relative font-medium">Look and Feel</h3>
    <p class="mt-2 text-lg">Choose a feedback link for this space, and modify the logo or brand color if needed.</p>
  </div>
  <div class="my-8 relative">
  <label class="vs-input--label">Choose Feedback link</label>
  <vx-input-group class="">
    <template slot="prepend">
      <div class="prepend-text text-dark pr-1" style="background: #FBEFFF;">
        

        <span v-if="!$store.getters['dash/agency'].isAgency">feedback.link/</span>
        <span v-else>
          <span v-if="$store.getters['dash/agency'].baseDomain">{{$store.getters['dash/agency'].baseDomain}}/</span>
          <span v-else>givefdbck.com/</span>
        </span>

      </div>
    </template>
    <vs-input name="feedback link" v-validate="'min:4|max:20'" data-vv-as="" v-model="feedbackAddress" />
  </vx-input-group>
  <span class="block my-2 text-primary" v-if="errors.first('feedback link')">Your feedback link must be between 4 - 20 characters.</span>
  <div class="pt_topright">
    <span class="" v-if="checkingFeedbackAddress" style="line-height: 2.3rem;">Checking...</span>
  </div>
  <div v-if="feedbackAddressValid === true" class="pt_topright">
    <vs-avatar class="w-6 h-6" color="success" icon-pack="feather" icon="icon-check" />
    <span class="text-success align-top" style="line-height: 2.3rem;">Available</span>
  </div>
  <div v-if="feedbackAddressValid === false" class="pt_topright">
    <vs-avatar class="w-6 h-6" color="danger" icon-pack="feather" icon="icon-x" />
    <span class="text-danger align-top" style="line-height: 2.3rem;">Taken</span>
  </div>
  <vs-collapse type="margin" :open-hover="true" class="small" >
    <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle">
      <div slot="header">
        What's this?
      </div>
      Choose a web address (link) your customers can visit to give feedback. Make sure it's short, easy to recall and identifiable with your business.  - e.g. If your business' name is Pat's Cupcakes, make your feedback link <span class="font-medium italic">feedback.link/pats</span>
    </vs-collapse-item>
  </vs-collapse>
  </div>


  <div v-if="$route.name === 'addnew' && !showLogoColor" class="mb-10">
    <p class="my-1">Logo & Color</p>
    <div class="pt_blue_div">Your new space will be created with the same branding as your other space(s).</div>
  </div>
  <div v-else>
  <div class="my-8 mb-10" >
  <div class="flex flex-wrap">
    <div class="w-full sm:w-1/2 sm:pr-3">
      <label class="vs-input--label">Primary color</label>
      <p class="text-sm sm:h-20 mb-5 sm:mb-0">Used for your survey background. Try to use your brand color here. </p>
      <chromepicker class="w-full" v-model="colorHex" :disableAlpha="true"/>
    </div>
    <div class="w-full sm:w-1/2 sm:pl-3 mt-6 sm:mt-0">
      <label class="vs-input--label">Secondary color</label>
      <p class="text-sm sm:h-20 mb-5 sm:mb-0">Used as a secondary color for buttons and decorations.</p>
      <chromepicker class="w-full" v-model="secondaryHex" :disableAlpha="true"/>
    </div>
  </div>
  </div>


  <div class="relative" >
  <label class="vs-input--label block" >Logo</label>
  <input type="file" style="display: none;" ref="logoInput" @change="filesChange($event.target.files)" accept="image/png, image/gif, image/jpeg">
  <p class="inline-block" style="max-width: 20rem;"><vs-switch class="float-right mt-2 ml-2" color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="iHaveLogo">
      <span slot="on">YES</span>
      <span slot="off">NO</span>
    </vs-switch>Do you have a logo of your business on your device?
  </p>

  <div v-if="iHaveLogo">
  <div class="my-6 optionalwrap">
  <vs-button  type="border" :color="logoUploaded? 'success':'primary'" @click.prevent="selectFile" class="w-full" :icon-pack="logoUploaded? 'feather':''" :icon="logoUploaded ? 'icon-check':''" >{{ logoButtonText }}</vs-button>
  <p class="my-4" v-if="!logoUploaded">Select a good quality version of your business logo, preferably in PNG format and not larger than 600kb.</p>
  <span class="text-primary" v-if="logoMessage">{{ logoMessage }}</span>
  <!-- <vs-button disabled color="black" type="border" @click="$emit('back')" class="w-full">Uploading...</vs-button>
  <vs-button color="success" type="border" icon-pack="feather" icon="icon-check" class="w-full">Uploaded</vs-button>-->

  <div v-if="logoUploaded">
    <vx-tooltip class="mt-3" text="Some logos require a white border around it for some extra padding.">
          <vs-checkbox v-model="showWhiteLogoBorder">Show white border</vs-checkbox>
    </vx-tooltip>
    <vx-tooltip class="mt-3" text="If you have a transparent logo, disable this.">
          <vs-checkbox v-model="showWhiteLogoBackground">Enable white background</vs-checkbox>
    </vx-tooltip>
  </div>

  </div>
  </div>
  <div class="pt_topright" v-if="logoLoading">
    <span class="text-primary font-medium">Uploading...</span>
  </div>
  </div>
  <div class="mt-6 flex items-center">
      <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
      <span class="inline-block max-w-lg text-light">Need help getting set up? <span class="font-medium">Continue with sign up</span> and <span class="font-medium">reach out</span> to support once inside your dashboard.</span>
    </div>
  </div>



  <div class="overflow-visible">
    <p class="text-primary clear-both text-lg my-8 mb-4 font-medium" v-if="message">{{ message }}</p>
    <vs-button size="large" type="flat" @click="$emit('back')" class="my-6 py-6 text-base lg:text-xl">< Back</vs-button>
    <vs-button size="large" class="float-right my-6 w-48 font-semibold py-6 text-base lg:text-xl lg:w-64 pmybtnshdw" @click="next"  icon-pack="feather" icon="icon-chevron-right" icon-after >Next</vs-button>
  </div>
  </div>
</template>


<script>

import {
  Chrome
} from 'vue-color'
import debounce from 'debounce'
import signupComputedVmodel from '../common/setSignupComputedVmodel'
import store from '../../../store/store'
import { firebase } from '../../../firebase/firebaseConfig'

let storageRef = firebase.storage().ref()

export default {
  data () {
    return {
      chosenLink: '',
      iHaveLogo: false,
      checkingFeedbackAddress: false,
      feedbackAddressValid: null,
      logoLoading: false,
      logoMessage: false,
      showLogoColor: false,
      message: false,
      logoUploaded: false,
      logoButtonText: 'Select Logo File'
    }
  },
  mounted() {
    if (this.feedbackAddress.trim() !== '') {
      checkFeedbackAddress(this.feedbackAddress)
    }
  },
  created () {
    if (this.$route.name === 'addnew') {
      if (this.$store.state.signUpState.recorded.appearance.logoUrl !== '') {
        this.iHaveLogo = true
        this.logoUploaded = true
        this.logoButtonText = 'Change Logo'
      }
    }
  },
  methods: {
    next () {

      if (this.feedbackAddress === "") {
        this.message = "You need to choose your feedback link!"
        return
      }

      if (this.errors.has('feedback link')) {
        this.message = "Your feedback link needs to be between 4 and 20 characters!"
        return
      }

      if (this.logoLoading) {
        this.message = "Your logo is still uploading."
        return
      }

      if (this.feedbackAddressValid === null) {
        this.message = "We're still checking if your chosen feedback link is valid."
        return
      }

      if (this.feedbackAddressValid === false) {
        this.message = "Your feedback link has already been taken - please choose another one."
        return
      }

      this.$emit('next')
      this.scrollToTop()

    },
    selectFile() {
      this.$refs.logoInput.click()
    },
    filesChange(target) {
      // NEED TO CROSS BROWSER TEST/READ UP ON FILE API ON BROWSERS/SUPPORT
      //noconsoleconsole.log('checking image validity..')
      this.message = false
      this.logoMessage = false
      if (typeof target[0] !== 'undefined') {
        let validation = this.validateLogo(target[0])
        let imgName = this.$store.state.signUpState.recorded.businessInfo.businessName + (new Date().getTime() / 1000)
        imgName = (imgName.replace(/[`~±!@#$%^&*()_|+\-=÷¿?;:'",.<> \{\}\[\]\\\/]/gi, '')).toLowerCase()
        imgName = imgName.replace(/[^\w\s]/gi, '')
        //console.log(storageRef)
        if (validation.passed) {
          let imageRef = storageRef.child('businesslogos/' + imgName)
          this.logoLoading = true
          this.logoMessage = ''
          //noconsoleconsole.log('uploading image..')
          imageRef.put(target[0]).then((snapshot) => {
            //noconsoleconsole.log('umage uploaded')
            snapshot.ref.getDownloadURL().then((dURL) => {
              //noconsoleconsole.log(dURL)
              this.$store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
                target: ['appearance', 'logoUrl'],
                value: dURL
              })
              this.logoUploaded = true
              this.logoLoading = false
              this.message = false
              this.logoButtonText = target[0].name
            }).catch((e) => {
              //noconsoleconsole.log(e)
            })
          }).catch((e) => {
            //noconsoleconsole.log(e)
            this.logoMessage = 'We couldn\'t upload your logo, please ensure it\'s not larger than 1MB and either a JPEG, GIF or PNG file.'
            this.logoLoading = false
          })
        } else {
          this.message = validation.reason
        }
      }
    },
    validateLogo(file) {
      if (typeof file.size !== 'undefined') {
        if (file.size > 1000000) {
          return {
            passed: false,
            reason: 'Your logo file may not be larger than 1MB in size'
          }
        }
      }
      if (typeof file.size !== 'undefined') {
        if ((file.type !== 'image/png') && (file.type !== 'image/jpeg') && (file.type !== 'image/gif')) {
          return {
            passed: false,
            reason: 'Your logo file needs to be a JPG, GIF or PNG file extension'
          }
        }
      }
      return {
        passed: true,
        reason: ''
      }
    },
    checkFeedbackAddress(val) {
      this.checkingFeedbackAddress = true
      this.$store.dispatch('signUpState/checkAddressRegistered', {
        val: val
      }).then((res) => {
        //console.log('res')
        //console.log(res)
        this.message = false
        if (res.res === true) {
          //noconsoleconsole.log('true, context')
          if (res.context === this.feedbackAddress) {
            this.feedbackAddressValid = true
          } else {
            this.feedbackAddressValid = null
            this.message = false
          }
        } else {
          if (res.context === this.feedbackAddress) {
            this.feedbackAddressValid = false
          } else {
            this.feedbackAddressValid = null
            this.message = false
          }
          this.checkingFeedbackAddress = true
          this.feedbackAddressValid = false
        }
        this.checkingFeedbackAddress = false
      }).catch((e) => {
        //console.log(e)
        this.message = false
        this.checkingFeedbackAddress = false
      })
    },
    debounceFeedbackInput: debounce(function(val) {
      //console.log(val)
      if (val.trim() !== '') {
        this.checkFeedbackAddress(val)
      }
    }, 700)
  },
  components: {
    chromepicker: Chrome
  },
  computed: {       
    showWhiteLogoBorder: signupComputedVmodel(store, ['appearance', 'showWhiteLogoBorder']),
    showWhiteLogoBackground: signupComputedVmodel(store, ['appearance', 'showWhiteLogoBackground']),
    secondaryHex: signupComputedVmodel(store, ['appearance', 'secondaryHex']),
    colorHex: signupComputedVmodel(store, ['appearance', 'backgroundHex']),
    fileUrl: signupComputedVmodel(store, ['appearance', 'logoUrl']),
    needHelpLogoColor: signupComputedVmodel(store, ['needHelpLogoColor']),
    feedbackAddress: {
      get() {
        return this.$store.state.signUpState.recorded['feedbackAddressHandle']
      },
      set(val) {
        this.$store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
          target: ['feedbackAddressHandle'],
          value: val.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()
        })
      }
    }
  },
  watch: {
    //colorHex (v) {      
      //console.log(v)
    //},
    iHaveLogo (v) {
      //IF I DESELECT I DONT HAVE LOGO, DESET LOGO
      this.message = false
      this.logoMessage = false
      if (v === false) {
        this.logoButtonText = 'Select Logo File'
        this.logoUploaded = false
        this.$store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
          target: ['appearance', 'logoUrl'],
          value: ''
        })
      }
    },
    feedbackAddress(val) {
        this.message = false
        if (val !== '') {
          if (val.length > 3) {
            this.feedbackAddressMessage = ''
            this.feedbackAddressValid = null
            this.checkingFeedbackAddress = true
            this.debounceFeedbackInput(val.replace(/[^a-zA-Z0-9]/g, ""))
          } else {
            this.feedbackAddressValid = null
          }
        } else {
          this.checkingFeedbackAddress = false
          this.feedbackAddressValid = null
          this.feedbackAddressMessage = ''
        }
    }
  }
}

</script>
